module.exports = __webpack_public_path__ + "media/src/shared_components/images/info_circle_icon-087364599f3e3b3c8aa75e8c8996363a.svg";